import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOther = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 2H6C6.552 2 7 2.448 7 3V6C7 6.552 6.552 7 6 7H3C2.448 7 2 6.552 2 6V3C2 2.448 2.448 2 3 2Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 2H13C13.552 2 14 2.448 14 3V6C14 6.552 13.552 7 13 7H10C9.448 7 9 6.552 9 6V3C9 2.448 9.448 2 10 2Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 9H6C6.552 9 7 9.448 7 10V13C7 13.552 6.552 14 6 14H3C2.448 14 2 13.552 2 13V10C2 9.448 2.448 9 3 9Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 9H13C13.552 9 14 9.448 14 10V13C14 13.552 13.552 14 13 14H10C9.448 14 9 13.552 9 13V10C9 9.448 9.448 9 10 9Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgOther;
